"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  "disciplines_cleaned": "Automatique",
  "experience_pro": "+ de 20 ans",
  "nbre": 6,
  "tjm_moyen": 575
}, {
  "disciplines_cleaned": "Automatique",
  "experience_pro": "11 à 20 ans",
  "nbre": 4,
  "tjm_moyen": 495
}, {
  "disciplines_cleaned": "Automatique",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 397
}, {
  "disciplines_cleaned": "Automatique",
  "experience_pro": "6 à 10 ans",
  "nbre": 3,
  "tjm_moyen": 437
}, {
  "disciplines_cleaned": "Automatique",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 351
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "experience_pro": "+ de 20 ans",
  "nbre": 6,
  "tjm_moyen": 714
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "experience_pro": "11 à 20 ans",
  "nbre": "",
  "tjm_moyen": 644
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 506
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "experience_pro": "6 à 10 ans",
  "nbre": 4,
  "tjm_moyen": 575
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 437
}, {
  "disciplines_cleaned": "Génie civil",
  "experience_pro": "+ de 20 ans",
  "nbre": 4,
  "tjm_moyen": 713
}, {
  "disciplines_cleaned": "Génie civil",
  "experience_pro": "11 à 20 ans",
  "nbre": 8,
  "tjm_moyen": 610
}, {
  "disciplines_cleaned": "Génie civil",
  "experience_pro": "2 à 5 ans",
  "nbre": 3,
  "tjm_moyen": 465
}, {
  "disciplines_cleaned": "Génie civil",
  "experience_pro": "6 à 10 ans",
  "nbre": 3,
  "tjm_moyen": 541
}, {
  "disciplines_cleaned": "Génie civil",
  "experience_pro": "Moins de 2 ans",
  "nbre": 3,
  "tjm_moyen": 406
}, {
  "disciplines_cleaned": "Génie mécanique",
  "experience_pro": "+ de 20 ans",
  "nbre": 19,
  "tjm_moyen": 650
}, {
  "disciplines_cleaned": "Génie mécanique",
  "experience_pro": "11 à 20 ans",
  "nbre": 9,
  "tjm_moyen": 495
}, {
  "disciplines_cleaned": "Génie mécanique",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 322
}, {
  "disciplines_cleaned": "Génie mécanique",
  "experience_pro": "6 à 10 ans",
  "nbre": 5,
  "tjm_moyen": 368
}, {
  "disciplines_cleaned": "Génie mécanique",
  "experience_pro": "Moins de 2 ans",
  "nbre": 2,
  "tjm_moyen": 299
}];
exports["default"] = _default;